<template>
  <div class="auth-main-wrapper col-lg-5 col-md-6 col-sm-12 mt-5">
    <div class="auth-inner-div w-100 text-center">
      <h3 class="auth-header">{{ $t('registration') }}</h3>
    </div>
    <div class="auth-inner-form-div">
      <div class="auth-input d-flex align-content-center checkbox">
        <CheckBoxComponent id="company_registration" name="company_registration" @onClick="form.isCompany = !form.isCompany">
          <template #checkbox-text>
            <label for="company_registration">
              {{ $t('company_registration') }}
            </label>
          </template>
        </CheckBoxComponent>
      </div>
      <div class="auth-input">
        <InputComponent v-for="input in form.inputs"
                        class="w-100 mx-auto"
                        :name-input="input.name"
                        :data-type="input.dataType"
                        :placeholder="$t(input.placeholder)"
                        v-model:data="input.value"
                        :msg="input.validation"></InputComponent>
      </div>
<!--      if not company    -->
<!--      <div v-if="!form.isCompany" class="auth-input pt-0">-->
      <div class="auth-input pt-0">
        <InputComponent v-for="input in form.customerInputs"
                        class="w-100 mx-auto"
                        :name-input="input.name"
                        :data-type="input.dataType"
                        :placeholder="$t(input.placeholder)"
                        v-model:data="input.value"
                        :msg="input.validation"></InputComponent>
      </div>
<!--      if company    -->
      <div v-if="form.isCompany" class="auth-input pt-0">
        <InputComponent v-for="input in form.companyInputs"
                        class="w-100 mx-auto"
                        :name-input="input.name"
                        :data-type="input.dataType"
                        :placeholder="$t(input.placeholder)"
                        v-model:data="input.value"
                        :msg="input.validation"></InputComponent>
      </div>
    </div>
    <div class="auth-inner-div w-100 pt-4">
      <button class="auth-customer-login-button w-100" @click.prevent="register" :disabled="loading" :class="{'less-padding-07': loading}">
        <span class="w-100">{{ $t('register') }}</span>
        <span class="customer-loader" v-if="loading"></span>
      </button>
    </div>
    <div class="auth-inner-div auth-bottom-sentence w-100 text-center">
      {{ $t('have_an_account') + ' ' }}
      <router-link class="blue" to="/login">{{ $t('login') }}</router-link>
    </div>
  </div>
</template>

<script lang="ts">
import "./customerRegistration.scss"

import axios from "axios";
import '../CustomerChangePassword/customerChangePassword.scss'
// @ts-ignore
import InputComponent from "../input/InputComponent.vue";
// @ts-ignore
import CheckBoxComponent from "../CheckBox/CheckBoxComponent.vue";
import type {IInput} from "@/interfaces/IInput.interface";
import FormValidationService from "../../services/formValidationService";
import {useStore} from "vuex";
import {defineComponent} from "vue";
import type {ICustomerRegistrationForm} from "@/interfaces/ICustomerRegistrationForm.interface";
import apiService from "../../services/apiService";
import type {ICustomerDataResponse} from "@/interfaces/ICustomerDataResponse.interface";
import NameOfHelper from "../../helpers/nameOfHelper";
import {routesConst} from "../../routes.js";

export default defineComponent({
  name: "CustomerRegistrationComponent",
  components: {
    CheckBoxComponent,
    InputComponent,
  },
  setup() {
    const store = useStore();

    return {
      store
    }
  },
  data() {
    return {
      customer: <ICustomerDataResponse> {},
      loading: false,
      form: <ICustomerRegistrationForm>{
        isValid: false,
        id: null,
        isCompany: false,
        inputs: <IInput[]>[
          <IInput>{
            key: 'email', // NOTE prop binded with store
            name: 'email',
            dataType: 'text',
            placeholder: 'email',
            // @ts-ignore
            value: this.store.state.customer.email ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'Please_Enter_your_email'},
                email: {message: 'Please_Enter_your_valid_email'},
                existing_customer: {message: 'existing_customer'},
              }
            }
          },
          <IInput>{
            key: 'password', // NOTE prop binded with store
            name: 'password',
            dataType: 'password',
            placeholder: 'password',
            value: null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {},
                password: {}
              }
            }
          },
        ],
        customerInputs: <IInput[]>[
          <IInput>{
            key: 'first_name', // NOTE prop binded with store
            name: 'first_name',
            dataType: 'text',
            placeholder: 'first_name',
            // @ts-ignore
            value: this.store.state.customer.first_name ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'please_enter_valid_first_name'}
              }
            }
          },
          <IInput>{
            key: 'last_name', // NOTE prop binded with store
            name: 'last_name',
            dataType: 'text',
            placeholder: 'last_name',
            // @ts-ignore
            value: this.store.state.customer.last_name ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'please_enter_valid_last_name'}
              }
            }
          },
          <IInput>{
            key: 'mobno', // NOTE prop binded with store
            name: 'mobno',
            dataType: 'tel',
            placeholder: 'phone',
            // @ts-ignore
            value: this.store.state.customer.mobno ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'please_enter_valid_phone'}
              }
            }
          },
        ],
        companyInputs: <IInput[]>[
          <IInput>{
            key: 'company_name', // NOTE prop binded with store
            name: 'company_name',
            dataType: 'text',
            placeholder: 'company_name',
            // @ts-ignore
            value: this.store.state.customer.company_name ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'please_enter_valid_company_name'}
              }
            }
          },
          <IInput>{
            key: 'company_number', // NOTE prop binded with store
            name: 'company_number',
            dataType: 'text',
            placeholder: 'company_code',
            // @ts-ignore
            value: this.store.state.customer.company_number ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'please_enter_valid_company_code'}
              }
            }
          },
          <IInput>{
            key: 'company_vat', // NOTE prop binded with store
            name: 'company_vat',
            dataType: 'text',
            placeholder: 'vat_code',
            // @ts-ignore
            value: this.store.state.customer.company_vat ?? null,
            validation: {
              state: true,
              message: null,
              rules: {}
            }
          },
          <IInput>{
            key: 'address', // NOTE prop binded with store
            name: 'address',
            dataType: 'text',
            placeholder: 'address',
            // @ts-ignore
            value: this.store.state.customer.address ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'please_enter_valid_company_address'}
              }
            }
          },
        ]
      },
    }
  },
  mounted() {
    if (this.$route.params.hash) {
      this.customerFromOrder(this.$route.params.hash);
    }
  },

  methods: {
    register(): void {
      this.loading = true;

      let isInputsValid = FormValidationService.validate(this.form.inputs);

      if (! isInputsValid) {
        this.loading = false;
        return;
      }

      let data = {
        'is_company': this.form.isCompany,
        'locale': this.store.state.general.locale
      };

      for (const prop in this.form.inputs) {
        data[this.form.inputs[prop].key] = this.form.inputs[prop].value;
      }

      // Prepare customer form data
      const isCustomerInputsValid = FormValidationService.validate(this.form.customerInputs);

      if (! isCustomerInputsValid) {
        this.loading = false;
        return;
      }

      for (const prop in this.form.customerInputs) {
        if (!this.form.customerInputs.hasOwnProperty(prop) ) {
          continue;
        }
        const input = this.form.customerInputs[prop];
        data[input.key] = input.value;
      }

      // Prepare company form data
      if (this.form.isCompany) {
        const isCompanyInputValid = FormValidationService.validate(this.form.companyInputs);

        if (! isCompanyInputValid) {
          this.loading = false;
          return;
        }

        for (const prop in this.form.companyInputs) {
          if (! this.form.companyInputs.hasOwnProperty(prop)) {
            continue;
          }
          const input = this.form.companyInputs[prop];
          data[input.key] = input.value;
        }

        // this.actualRequest(data);
        // return;
      }

      // // Or prepare customer form data
      // const isCustomerInputsValid = FormValidationService.validate(this.form.customerInputs);
      //
      // if (! isCustomerInputsValid) {
      //   this.loading = false;
      //   return;
      // }
      //
      // for (const prop in this.form.customerInputs) {
      //   if (!this.form.customerInputs.hasOwnProperty(prop) ) {
      //     continue;
      //   }
      //   const input = this.form.customerInputs[prop];
      //   data[input.key] = input.value;
      // }

      this.actualRequest(data);
    },
    actualRequest(data): void {
      axios.post(apiService.customerRegister() + (this.store.state.customer.hash ? '/' + this.store.state.customer.hash as string : ''), data)
          .then(response => {
            this.store.commit('customer/CLEAR_STATE');
            this.$router.push(routesConst.LOGIN);
          })
          .catch(error => {
            console.error(error);

            if (error.response?.data?.errors?.email) {

              const state = this.store.state.customer;
              const nameOf = (c) => NameOfHelper.obj(c);

              this.store.commit( 'customer/SET_STATE_PROP_VALUE', [
                {prop: nameOf(() => state.error_existing_customer), value: true},

              ]);

              FormValidationService.validate(this.form.inputs);

              this.store.commit( 'customer/SET_STATE_PROP_VALUE', [
                {prop: nameOf(() => state.error_existing_customer), value: false},

              ]);
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
    customerFromOrder(hash) {
      axios.post(apiService.getCustomerData(), {hash})
          .then(response => {
            this.customer = <ICustomerDataResponse> response.data;

            const parts = this.customer?.first_name?.split(' ');
            this.customer.first_name = parts?.length ? parts[0] : null;
            this.customer.last_name = parts?.length ? parts[1] : null;

            const state = this.store.state.customer;
            const nameOf = (c) => NameOfHelper.obj(c);

            this.store.commit( 'customer/SET_STATE_PROP_VALUE', [
              {prop: nameOf(() => state.first_name), value: this.customer.first_name},
              {prop: nameOf(() => state.last_name), value: this.customer.last_name},
              {prop: nameOf(() => state.email), value: this.customer.email},
              {prop: nameOf(() => state.mobno), value: this.customer.mobno},
              {prop: nameOf(() => state.company_name), value: this.customer.company_name},
              {prop: nameOf(() => state.company_number), value: this.customer.company_number },
              {prop: nameOf(() => state.company_vat), value: this.customer.company_vat},
              {prop: nameOf(() => state.address), value: this.customer.address},
              {prop: nameOf(() => state.hash), value: this.$route.params.hash},
            ]);

            for (const input of [this.form.inputs[0], ...this.form.customerInputs, ...this.form.companyInputs]) {
              input.value = this.store.state.customer[input.key];

            }

            if(this.store.state.customer.company_name) {
              this.form.isCompany = true;
            }

            window.history.pushState("", "", '/register');
          })
          .catch(error => {
            console.error(error)
          })
    }
  }
});
</script>